import React from 'react';
import ReactDOM from 'react-dom';
import videojs from 'video.js';
const Button = videojs.getComponent('Button');
class SpeedButton extends Button {
    constructor(player, options, props) {
        super(player, options);
        this.addClass('selector-button');
        this.removeClass('vjs-button');
        this.removeClass('vjs-control');
        this.on('click', (e) => {
            props.handleClick(e);
        });
        this.on('tap', (e) => {
            props.handleClick(e);
        });
        if (props.selected) {
            this.addClass('selected');
        }
        else {
            this.removeClass('selected');
        }
        this.setAttribute('value', props.value.toString());
        player.ready(() => {
            this.mount(props.value);
        });
    }
    mount(value) {
        ReactDOM.render(React.createElement(React.Fragment, null,
            value.toFixed(1),
            "x"), this.el());
    }
}
export default SpeedButton;
//# sourceMappingURL=SpeedButton.js.map